import { render, staticRenderFns } from "./servicesTpl.vue?vue&type=template&id=3eac74af&"
import script from "./servicesTpl.vue?vue&type=script&lang=js&"
export * from "./servicesTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports